// import React, { FC, memo, ReactNode, useEffect, useRef } from "react";
// import ReactDOM from "react-dom";
//
// import styles from "./style.module.css";
//
// type Props = {
//   text: string;
//   customClass?: string;
//   parentCustomClass?: string;
//   bgColor?: string;
//   children: ReactNode;
//   stickBottom?: boolean;
//   arrowPlacement?:
//     | "top-left"
//     | "top-center"
//     | "top-right"
//     | "bottom-left"
//     | "bottom-center"
//     | "bottom-right";
// };
// let _popup: any = null;
// const Tooltip: FC<Props> = ({
//   text,
//   children,
//   stickBottom = false,
//   arrowPlacement = "top-center",
//   customClass = "",
//   parentCustomClass = "",
//   bgColor,
// }) => {
//   const renderArrowPlacement = (
//     arrowPlacement:
//       | "top-left"
//       | "top-center"
//       | "top-right"
//       | "bottom-left"
//       | "bottom-center"
//       | "bottom-right"
//   ) => {
//     switch (arrowPlacement) {
//       case "top-left":
//         return `tooltip topLeft ${stickBottom ? "" : ""}`;
//       case "top-center":
//         return `tooltip topCenter ${stickBottom ? "" : ""}`;
//       case "top-right":
//         return `tooltip topRight ${stickBottom ? "" : ""}`;
//       case "bottom-left":
//         return `tooltip bottomLeft ${stickBottom ? "!mt-0" : ""}`;
//       case "bottom-center":
//         return `tooltip bottomCenter ${stickBottom ? "!mt-0" : ""}`;
//       case "bottom-right":
//         return `tooltip bottomRight ${stickBottom ? "!mt-0" : ""}`;
//       default:
//         return `tooltip topCenter ${stickBottom ? "!mb-0" : ""}`;
//     }
//   };
//   const setCoordinate = (
//     arrowPlacement:
//       | "top-left"
//       | "top-center"
//       | "top-right"
//       | "bottom-left"
//       | "bottom-center"
//       | "bottom-right"
//   ) => {
//     if (elementRef.current) {
//       switch (arrowPlacement) {
//         case "top-left": {
//           _popup.style.bottom = `${
//             window.innerHeight -
//             elementRef.current?.getBoundingClientRect().bottom +
//             elementRef.current?.getBoundingClientRect().height -
//             window.scrollY
//           }px`;
//           _popup.style.left = `${
//             elementRef.current?.getBoundingClientRect().left
//           }px`;
//           break;
//         }
//         case "top-center": {
//           _popup.style.bottom = `${
//             window.innerHeight -
//             elementRef.current?.getBoundingClientRect().bottom +
//             elementRef.current?.getBoundingClientRect().height -
//             window.scrollY
//           }px`;
//           _popup.style.left = `${
//             elementRef.current?.clientWidth / 2 +
//             elementRef.current?.getBoundingClientRect().left
//           }px`;
//           break;
//         }
//         case "top-right": {
//           _popup.style.bottom = `${
//             window.innerHeight -
//             elementRef.current?.getBoundingClientRect().bottom +
//             elementRef.current?.getBoundingClientRect().height -
//             window.scrollY
//           }px`;
//           _popup.style.right = `${
//             window.innerWidth -
//             elementRef.current?.getBoundingClientRect().right
//           }px`;
//           break;
//         }
//         case "bottom-left": {
//           _popup.style.top = `${
//             elementRef.current?.getBoundingClientRect().top +
//             elementRef.current?.getBoundingClientRect().height +
//             window.scrollY
//           }px`;
//           _popup.style.left = `${
//             elementRef.current?.getBoundingClientRect().left
//           }px`;
//           break;
//         }
//         case "bottom-center": {
//           _popup.style.top = `${
//             elementRef.current?.getBoundingClientRect().top +
//             elementRef.current?.getBoundingClientRect().height +
//             window.scrollY
//           }px`;
//           _popup.style.right = `${
//             elementRef.current?.getBoundingClientRect().right
//           }px`;
//           break;
//         }
//         case "bottom-right": {
//           _popup.style.top = `${
//             elementRef.current?.getBoundingClientRect().top +
//             elementRef.current?.getBoundingClientRect().height +
//             window.scrollY
//           }px`;
//           _popup.style.right = `${
//             window.innerWidth -
//             elementRef.current?.getBoundingClientRect().right
//           }px`;
//           break;
//         }
//         default: {
//           break;
//         }
//       }
//     }
//   };
//   const elementRef = useRef<HTMLDivElement | null>(null);
//   useEffect(() => {
//     return () => {
//       if (_popup) {
//         try {
//           ReactDOM.unmountComponentAtNode(_popup);
//           document.body.removeChild(_popup);
//         } catch {}
//         _popup = null;
//       }
//     };
//   }, []);
//   const onMouseLeave = () => {
//     if (_popup) {
//       document.body.removeChild(_popup);
//       _popup = null;
//     }
//   };
//   const onMouseEnter = () => {
//     _popup = document.createElement("div");
//     _popup.className = "absolute tooltip-wrapper";
//     _popup.style.zIndex = "999";
//
//     document.body.appendChild(_popup);
//     ReactDOM.render(
//       <div
//         className={`${customClass} ${bgColor ? bgColor : ""} ${styles.tooltip}
//         ${renderArrowPlacement(arrowPlacement)}`}
//         dangerouslySetInnerHTML={{ __html: text }}
//       />,
//       _popup
//     );
//     setCoordinate(arrowPlacement);
//     setTimeout(() => {
//       if (_popup) {
//         _popup.className = "absolute tooltip-wrapper tooltip-wrapper__show";
//       }
//     }, 10);
//   };
//   const onTouchStart = () => {
//     if (_popup) {
//       onMouseLeave();
//     } else {
//       onMouseEnter();
//     }
//   };
//   return (
//     <div className={`${parentCustomClass} ${styles.tooltipWrapper}`}>
//       <div
//         className={`${styles.element}`}
//         ref={elementRef}
//         onFocus={onMouseEnter}
//         onBlur={onMouseLeave}
//       >
//         {children}
//       </div>
//     </div>
//   );
// };
//
// export default memo(Tooltip);
import React, { FC, memo, ReactNode, useEffect, useRef, useState } from "react";

import styles from "./style.module.css";

type Props = {
  text: string;
  customClass?: string;
  parentCustomClass?: string;
  bgColor?: string;
  children: ReactNode;
  isFullWidth?: boolean;
  stickBottom?: boolean;
  asFixedPosition?: boolean;
  arrowPlacement?:
    | "top-left"
    | "top-center"
    | "top-right"
    | "bottom-left"
    | "bottom-center"
    | "bottom-right";
};

const Tooltip: FC<Props> = ({
  text,
  children,
  isFullWidth = false,
  stickBottom = false,
  arrowPlacement = "top-center",
  customClass = "",
  parentCustomClass = "",
  bgColor,
  asFixedPosition = false,
}) => {
  const elementRef = useRef<HTMLDivElement | null>(null);
  const [coordinates, setCoordinatesX] = useState<any>();
  const renderArrowPlacement = (
    arrowPlacement:
      | "top-left"
      | "top-center"
      | "top-right"
      | "bottom-left"
      | "bottom-center"
      | "bottom-right"
  ) => {
    switch (arrowPlacement) {
      case "top-left":
        return `tooltip topLeft ${stickBottom ? "!mb-0" : ""}`;
      case "top-center":
        return `tooltip topCenter ${stickBottom ? "!mb-0" : ""}`;
      case "top-right":
        return `tooltip topRight ${stickBottom ? "!mb-0" : ""}`;
      case "bottom-left":
        return `tooltip bottomLeft ${stickBottom ? "!mt-0" : ""}`;
      case "bottom-center":
        return `tooltip bottomCenter ${stickBottom ? "!mt-0" : ""}`;
      case "bottom-right":
        return `tooltip bottomRight ${stickBottom ? "!mt-0" : ""}`;
      default:
        return `tooltip topCenter ${stickBottom ? "!mb-0" : ""}`;
    }
  };
  const setCoordinate = (
    arrowPlacement:
      | "top-left"
      | "top-center"
      | "top-right"
      | "bottom-left"
      | "bottom-center"
      | "bottom-right"
  ) => {
    if (elementRef.current) {
      switch (arrowPlacement) {
        case "top-left": {
          setCoordinatesX({
            bottom: `${
              window.innerHeight -
              elementRef.current?.getBoundingClientRect().bottom +
              elementRef.current?.getBoundingClientRect().height
            }px`,
            left: `${elementRef.current?.getBoundingClientRect().left}px`,
          });
          // _popup.style.bottom = `${
          //   window.innerHeight -
          //   elementRef.current?.getBoundingClientRect().bottom +
          //   elementRef.current?.getBoundingClientRect().height -
          //   window.scrollY
          // }px`;
          // _popup.style.left = `${
          //   elementRef.current?.getBoundingClientRect().left
          // }px`;
          break;
        }
        case "top-center": {
          // _popup.style.bottom = `${
          //   window.innerHeight -
          //   elementRef.current?.getBoundingClientRect().bottom +
          //   elementRef.current?.getBoundingClientRect().height -
          //   window.scrollY
          // }px`;
          // _popup.style.left = `${
          //   elementRef.current?.clientWidth / 2 +
          //   elementRef.current?.getBoundingClientRect().left
          // }px`;
          setCoordinatesX({
            bottom: `${
              window.innerHeight -
              elementRef.current?.getBoundingClientRect().bottom +
              elementRef.current?.getBoundingClientRect().height -
              window.scrollY
            }px`,
            left: `${
              elementRef.current?.clientWidth / 2 +
              elementRef.current?.getBoundingClientRect().left
            }px`,
          });
          break;
        }
        case "top-right": {
          setCoordinatesX({
            bottom: `${
              window.innerHeight -
              elementRef.current?.getBoundingClientRect().bottom +
              elementRef.current?.getBoundingClientRect().height
            }px`,
            right: `${
              window.innerWidth -
              elementRef.current?.getBoundingClientRect().right
            }px`,
          });
          // _popup.style.bottom = `${
          //   window.innerHeight -
          //   elementRef.current?.getBoundingClientRect().bottom +
          //   elementRef.current?.getBoundingClientRect().height -
          //   window.scrollY
          // }px`;
          // _popup.style.right = `${
          //   window.innerWidth -
          //   elementRef.current?.getBoundingClientRect().right
          // }px`;

          break;
        }
        case "bottom-left": {
          // _popup.style.top = `${
          //   elementRef.current?.getBoundingClientRect().top +
          //   elementRef.current?.getBoundingClientRect().height +
          //   window.scrollY
          // }px`;
          // _popup.style.left = `${
          //   elementRef.current?.getBoundingClientRect().left
          // }px`;
          break;
        }
        case "bottom-center": {
          // _popup.style.top = `${
          //   elementRef.current?.getBoundingClientRect().top +
          //   elementRef.current?.getBoundingClientRect().height +
          //   window.scrollY
          // }px`;
          // _popup.style.right = `${
          //   elementRef.current?.getBoundingClientRect().right
          // }px`;
          break;
        }
        case "bottom-right": {
          // _popup.style.top = `${
          //   elementRef.current?.getBoundingClientRect().top +
          //   elementRef.current?.getBoundingClientRect().height +
          //   window.scrollY
          // }px`;
          // _popup.style.right = `${
          //   window.innerWidth -
          //   elementRef.current?.getBoundingClientRect().right
          // }px`;
          setCoordinatesX({
            top: `${
              elementRef.current?.getBoundingClientRect().top +
              elementRef.current?.getBoundingClientRect().height +
              window.scrollY
            }px`,
            right: `${
              window.innerWidth -
              elementRef.current?.getBoundingClientRect().right
            }px`,
          });
          break;
        }
        default: {
          break;
        }
      }
    }
  };
  // useEffect(() => {
  //
  // }, [arrowPlacement]);
  const onMouseEnter = () => {
    if (asFixedPosition) {
      setCoordinate(arrowPlacement);
    }
  };
  return (
    <div
      className={`${parentCustomClass} ${styles.tooltipWrapper}`}
      ref={elementRef}
    >
      <div className={styles.element} onMouseEnter={onMouseEnter}>
        {children}
      </div>
      <div
        style={coordinates}
        className={`${customClass} ${bgColor ? bgColor : ""} ${styles.tooltip}
        ${isFullWidth ? "!w-full !max-w-[100%]" : ""} ${
          asFixedPosition ? "fixed" : "absolute"
        }
        ${renderArrowPlacement(arrowPlacement)}`}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
};

export default memo(Tooltip);
